import { render, staticRenderFns } from "./BtnAddEditTeacher.vue?vue&type=template&id=47948180&"
import script from "./BtnAddEditTeacher.vue?vue&type=script&lang=js&"
export * from "./BtnAddEditTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports